import Aboutus from "../components/Aboutus";

function AboutusPage(){
    return(
        <Aboutus/>
    )
}

export default AboutusPage